import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect } from 'react';
import { setAllPermisosReportes, setReporteVentas } from '../reducer';
import { useUpdateEffect } from 'primereact/hooks';
import { isEmpty } from 'lodash';
import { ALL_PERMISOS_REPORTES, findPermission, REPORTE_VENTAS } from '../../../../utilities/permission';
import { Checkbox } from 'primereact/checkbox';

const ReportePermiso = () => {
    const asignaciones = useSelector((state) => state.usuario.asignaciones);
    const emisorSeleccionado = useSelector((state) => state.usuario.emisorSeleccionado);

    //Permisos relacionados con los reportes
    const { allPermisosReportes, reporteVentas } = useSelector((state) => state.usuario);

    const dispatch = useDispatch();

    const flipFeatures = useCallback(
        (flag) => {
            dispatch(setAllPermisosReportes(flag));
            dispatch(setReporteVentas(flag));
        },
        [dispatch]
    );

    useUpdateEffect(() => {
        if (allPermisosReportes) {
            flipFeatures(true);
            return;
        }
        flipFeatures(false);
    }, [allPermisosReportes]);

    useEffect(() => {
        if (isEmpty(asignaciones) || isEmpty(emisorSeleccionado)) {
            flipFeatures(false);
            return;
        }

        const asignacion = asignaciones[emisorSeleccionado.ruc];
        if (isEmpty(asignacion?.permisos)) {
            flipFeatures(false);
            return;
        }

        //set everything back to false,
        flipFeatures(false);

        //If all is assigned, then we have nothing else to check
        if (findPermission(ALL_PERMISOS_REPORTES, asignacion.permisos) > -1) {
            flipFeatures(true);
            return;
        }

        if (findPermission(REPORTE_VENTAS, asignacion.permisos) > -1) {
            dispatch(setReporteVentas(true));
        }
    }, [asignaciones, emisorSeleccionado, dispatch, flipFeatures]);

    return (
        <div className="flex flex-row justify-content-center  align-items-center gap-3">
            <div className="flex align-items-center">
                <Checkbox
                    inputId="allPermisosReportes"
                    onChange={(e) => {
                        dispatch(setAllPermisosReportes(e.target.checked));
                    }}
                    checked={allPermisosReportes}
                />
                <label htmlFor="allPermisosReportes" className="ml-2">
                    Todos
                </label>
            </div>
            <div className="flex align-items-center">
                <Checkbox
                    inputId="reporteVentas"
                    onChange={(e) => {
                        dispatch(setReporteVentas(e.target.checked));
                    }}
                    checked={reporteVentas}
                />
                <label htmlFor="reporteVentas" className="ml-2">
                    Reporte ventas
                </label>
            </div>
        </div>
    );
};

export default ReportePermiso;
